// Multi-theme system for the School ERP — applied via CSS variables on document.documentElement.
// Each theme has primary, accent, sidebar bg, navigation bg, gradient pair, hero text.

export const THEMES = {
  "royal-indigo": {
    label: "Royal Indigo",
    description: "Premium school feel · Indigo + Gold",
    primary: "#312E81", // indigo-900
    primaryHover: "#3730A3", // indigo-800
    primaryFg: "#FFFFFF",
    accent: "#D97706", // amber/gold
    accentFg: "#FFFFFF",
    topbar: "#1E1B4B", // indigo-950
    topbarFg: "#E0E7FF",
    nav: "#FFFFFF",
    navFg: "#312E81",
    surface: "#FFFFFF",
    background: "#F8FAFC",
    border: "#E2E8F0",
    ring: "#6366F1",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #312E81 0%, #4338CA 50%, #6366F1 100%)",
    seal: "#FBBF24",
  },
  "emerald-heritage": {
    label: "Emerald Heritage",
    description: "Eco/Heritage · Emerald + Warm Beige",
    primary: "#065F46", // emerald-800
    primaryHover: "#047857",
    primaryFg: "#FFFFFF",
    accent: "#B45309", // amber-700
    accentFg: "#FFFFFF",
    topbar: "#064E3B", // emerald-900
    topbarFg: "#D1FAE5",
    nav: "#FAF7F0",
    navFg: "#065F46",
    surface: "#FFFFFF",
    background: "#FAF7F0",
    border: "#E7DDC9",
    ring: "#10B981",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #064E3B 0%, #047857 50%, #10B981 100%)",
    seal: "#B45309",
  },
  "navy-coral": {
    label: "Navy & Coral",
    description: "Modern Sporty · Navy + Coral",
    primary: "#0C4A6E", // sky-900
    primaryHover: "#075985",
    primaryFg: "#FFFFFF",
    accent: "#F43F5E", // rose-500
    accentFg: "#FFFFFF",
    topbar: "#082F49",
    topbarFg: "#E0F2FE",
    nav: "#FFFFFF",
    navFg: "#0C4A6E",
    surface: "#FFFFFF",
    background: "#F0F9FF",
    border: "#BAE6FD",
    ring: "#38BDF8",
    success: "#16A34A",
    warning: "#F59E0B",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #082F49 0%, #0C4A6E 50%, #0369A1 100%)",
    seal: "#F43F5E",
  },
  "burgundy-classic": {
    label: "Burgundy Classic",
    description: "Prestigious Classic · Burgundy + Cream",
    primary: "#7F1D1D", // red-900
    primaryHover: "#991B1B",
    primaryFg: "#FFFFFF",
    accent: "#92400E",
    accentFg: "#FFFFFF",
    topbar: "#450A0A",
    topbarFg: "#FEE2E2",
    nav: "#FFFBF5",
    navFg: "#7F1D1D",
    surface: "#FFFFFF",
    background: "#FFFBF5",
    border: "#F5E6D3",
    ring: "#DC2626",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #450A0A 0%, #7F1D1D 50%, #991B1B 100%)",
    seal: "#D97706",
  },
  "midnight-cyan": {
    label: "Midnight Cyan",
    description: "Tech-modern · Midnight + Cyan",
    primary: "#0F172A",
    primaryHover: "#1E293B",
    primaryFg: "#FFFFFF",
    accent: "#06B6D4",
    accentFg: "#FFFFFF",
    topbar: "#020617",
    topbarFg: "#E2E8F0",
    nav: "#FFFFFF",
    navFg: "#0F172A",
    surface: "#FFFFFF",
    background: "#F8FAFC",
    border: "#E2E8F0",
    ring: "#06B6D4",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #020617 0%, #0F172A 50%, #06B6D4 100%)",
    seal: "#06B6D4",
  },
  "atlas-teal": {
    label: "Atlas Teal",
    description: "Contemporary Academic · Deep Teal + Sand",
    primary: "#115E59",
    primaryHover: "#0F766E",
    primaryFg: "#FFFFFF",
    accent: "#C2410C",
    accentFg: "#FFFFFF",
    topbar: "#042F2E",
    topbarFg: "#CCFBF1",
    nav: "#FFFCF5",
    navFg: "#115E59",
    surface: "#FFFFFF",
    background: "#F8FAFC",
    border: "#D1FAE5",
    ring: "#14B8A6",
    success: "#16A34A",
    warning: "#EA580C",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #042F2E 0%, #115E59 50%, #14B8A6 100%)",
    seal: "#C2410C",
  },
  "graphite-lime": {
    label: "Graphite Lime",
    description: "Bold Future-ready · Graphite + Electric Lime",
    primary: "#1F2937",
    primaryHover: "#111827",
    primaryFg: "#FFFFFF",
    accent: "#84CC16",
    accentFg: "#1F2937",
    topbar: "#0B1220",
    topbarFg: "#E5E7EB",
    nav: "#FFFFFF",
    navFg: "#1F2937",
    surface: "#FFFFFF",
    background: "#F3F4F6",
    border: "#D1D5DB",
    ring: "#84CC16",
    success: "#16A34A",
    warning: "#F59E0B",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #0B1220 0%, #1F2937 55%, #84CC16 100%)",
    seal: "#84CC16",
  },
  "sunset-terracotta": {
    label: "Sunset Terracotta",
    description: "Warm Modern · Terracotta + Slate Blue",
    primary: "#9A3412",
    primaryHover: "#C2410C",
    primaryFg: "#FFFFFF",
    accent: "#1D4ED8",
    accentFg: "#FFFFFF",
    topbar: "#7C2D12",
    topbarFg: "#FFEDD5",
    nav: "#FFFBF8",
    navFg: "#9A3412",
    surface: "#FFFFFF",
    background: "#FFF7ED",
    border: "#FED7AA",
    ring: "#FB923C",
    success: "#16A34A",
    warning: "#F59E0B",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #7C2D12 0%, #C2410C 50%, #1D4ED8 100%)",
    seal: "#1D4ED8",
  },
  "arctic-mint": {
    label: "Arctic Mint",
    description: "Light Premium · Cool Gray + Mint",
    primary: "#334155",
    primaryHover: "#1E293B",
    primaryFg: "#FFFFFF",
    accent: "#059669",
    accentFg: "#FFFFFF",
    topbar: "#0F172A",
    topbarFg: "#E2E8F0",
    nav: "#F8FAFC",
    navFg: "#334155",
    surface: "#FFFFFF",
    background: "#F1F5F9",
    border: "#CBD5E1",
    ring: "#10B981",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #0F172A 0%, #334155 50%, #10B981 100%)",
    seal: "#10B981",
  },
  "ocean-ember": {
    label: "Ocean Ember",
    description: "Vibrant Contemporary · Ocean Blue + Ember",
    primary: "#1E3A8A",
    primaryHover: "#1D4ED8",
    primaryFg: "#FFFFFF",
    accent: "#EA580C",
    accentFg: "#FFFFFF",
    topbar: "#172554",
    topbarFg: "#DBEAFE",
    nav: "#FFFFFF",
    navFg: "#1E3A8A",
    surface: "#FFFFFF",
    background: "#EFF6FF",
    border: "#BFDBFE",
    ring: "#F97316",
    success: "#16A34A",
    warning: "#F59E0B",
    danger: "#DC2626",
    gradient: "linear-gradient(135deg, #172554 0%, #1E3A8A 50%, #EA580C 100%)",
    seal: "#EA580C",
  },
};

export const DEFAULT_THEME = "royal-indigo";

export function applyTheme(themeKey) {
  const t = THEMES[themeKey] || THEMES[DEFAULT_THEME];
  const r = document.documentElement;
  Object.entries(t).forEach(([k, v]) => {
    if (typeof v === "string" && v.startsWith("linear-gradient")) {
      r.style.setProperty(`--erp-gradient`, v);
    } else if (typeof v === "string") {
      r.style.setProperty(`--erp-${k}`, v);
    }
  });
  return t;
}
